import { api } from "@/lib/api/client";
import type { InviteStatus, Invitee, Meeting } from "@/lib/api/types";

export type InviteView = {
  meeting: Meeting;
  invitee: Invitee;
};

export function readInvite(token: string): Promise<InviteView> {
  return api<InviteView>(`invites/${token}`, { anonymous: true });
}

export function respondToInvite(token: string, status: InviteStatus): Promise<InviteView> {
  return api<InviteView>(`invites/${token}/respond`, {
    method: "POST",
    body: { status },
    anonymous: true,
  });
}
